import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.card',
    method: 'get',
    params,
  })
}

export const listCardLabels = (params?: any) => {
  return axiosService({
    url: '/api.card-label',
    method: 'get',
    params,
  })
}

export const listAllCards = (params?: any) => {
  return axiosService({
    url: '/api.card/all',
    method: 'get',
    params,
  })
}

export const listMyCards = (params?: any) => {
  return axiosService({
    url: '/api.card/assigned',
    method: 'get',
    params,
  })
}

export const listAssignCards = (params?: any) => {
  return axiosService({
    url: '/api.card/created',
    method: 'get',
    params,
  })
}

export const listCompletedCards = (params?: any) => {
  return axiosService({
    url: '/api.card/completed',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.card/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.card/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.card/${id}`,
    method: 'put',
    data,
  })
}

export const reschedule = (id: number, data: any) => {
  return axiosService({
    url: `/api.card/${id}/reschedule`,
    method: 'put',
    data,
  })
}

export const process = (id: number) => {
  return axiosService({
    url: `/api.card/${id}/process`,
    method: 'put',
  })
}

export const complete = (id: number) => {
  return axiosService({
    url: `/api.card/${id}/complete`,
    method: 'put',
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.card/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.card',
    method: 'post',
    data,
  })
}
